import { Box, Typography, useTheme } from '@mui/material';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import useFetch from '../../api/useFetch';
import { useConfig } from '../../api/api';
import RenderHTML from '../../components/preview/RenderHTML';
import StyledTextContainer from '../../components/preview/StyledTextContainer';
import Div100vh from 'react-div-100vh';
import Loader from '../../components/special/Loader';
import Cookies from 'universal-cookie';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../global/theme/tokens';

const PrivacyPolicy = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const cookies = new Cookies();
  const colorMode = cookies.get('colorMode');
  const { t } = useTranslation();
  const config = useConfig();
  const { apiData } = useFetch('privacy-policy');

  const ownCompanyData = config?.owncompanydata;

  const logo =
    ownCompanyData?.logoDark || ownCompanyData?.logoLight
      ? colorMode !== 'dark' && ownCompanyData?.logoLight
        ? ownCompanyData.logoLight.temporaryUrl
        : (ownCompanyData.logoDark || ownCompanyData.logoLight).temporaryUrl
      : colorMode === 'dark'
        ? '/assets/svg/exopaper-text-darkmode.svg'
        : '/assets/svg/exopaper-text.svg';

  return (
    <Div100vh>
      <img
        src={
          colorMode === 'dark'
            ? '/assets/uploads/background-dark.webp'
            : '/assets/uploads/background-bright.webp'
        }
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          position: 'absolute',
          top: '0',
          left: '0',
          objectPosition: '32%',
          zIndex: '-5',
        }}
      />
      <Box className="p-2 sm:py-5 w-full h-full overflow-y-auto flex flex-col items-center gap-4 md:gap-8">
        <Box
          className="mx-auto w-fit px-5 py-3 rounded-lg backdrop-blur-lg"
          sx={{ bgcolor: colors.glass }}
        >
          <Typography variant="h4" className="flex items-center gap-4">
            <img src={logo} className="h-8 sm:h-10" alt="" />
            {t('Privacy Policy')}
          </Typography>
        </Box>
        {!apiData ? (
          <Loader active={true} />
        ) : (
          <>
            <Box
              className=" backdrop-blur-lg rounded-lg p-4"
              sx={{ maxWidth: '800px;', bgcolor: colors.glass }}
            >
              <StyledTextContainer
                fullWidth
                backgroundColor={'transparent'}
                className="w-full"
              >
                <RenderHTML HTML={apiData.data} />
              </StyledTextContainer>
            </Box>
            {(ownCompanyData?.telephoneNumber ||
              ownCompanyData?.mailAddress) && (
              <Box
                className="mx-auto w-fit px-5 py-3 rounded-lg backdrop-blur-lg flex flex-wrap justify-center items-center gap-x-6 gap-y-1"
                sx={{ bgcolor: colors.glass }}
              >
                {ownCompanyData?.telephoneNumber && (
                  <a
                    href={'tel:' + ownCompanyData.telephoneNumber}
                    className="flex items-center gap-2"
                  >
                    <LocalPhoneIcon sx={{ fontSize: '18px' }} />
                    <Typography>{ownCompanyData.telephoneNumber}</Typography>
                  </a>
                )}
                {ownCompanyData?.mailAddress && (
                  <a
                    href={'mailto:' + ownCompanyData.mailAddress}
                    className="flex items-center gap-2"
                  >
                    <EmailIcon sx={{ fontSize: '18px' }} />
                    <Typography>{ownCompanyData.mailAddress}</Typography>
                  </a>
                )}
              </Box>
            )}
          </>
        )}
      </Box>
    </Div100vh>
  );
};

export default PrivacyPolicy;
